import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useRef } from 'react';
import i18n from 'i18next';
import { useFormFieldContext } from 'components/FormField';
import Pill from 'components/Pill';
import TagInput from 'components/TagInput';
import { Combobox, ComboboxInput, ComboboxMenu, ComboBoxMenuGroupLabel, ComboboxMenuItem, ComboBoxMenuItemDivider } from 'components/Combobox';
import useMergedRefs from 'hooks/useMergedRefs';
import { KEY } from 'utils/ui/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function getOptionDivider() {
  return {
    __isDivider: true
  };
}
export function getOptionGroupLabel(label) {
  return {
    label: label,
    __isGroupLabel: true
  };
}
var isGroupLabel = function isGroupLabel(option) {
  return '__isGroupLabel' in option;
};
var isDivider = function isDivider(option) {
  return '__isDivider' in option;
};
var getDefaultMenuItemLabel = function getDefaultMenuItemLabel(item) {
  return item.title || item.value;
};
function defaultItemRenderer(_ref) {
  var item = _ref.item,
    removeItem = _ref.removeItem;
  var commonPillProps = {
    children: item.title || item.value,
    icon: item.alert ? 'flag' : item.icon,
    iconColor: item.alert ? 'negative' : undefined,
    mr: 'xxs',
    my: 1,
    dimmed: item.isIndeterminate
  };
  if (removeItem) {
    return /*#__PURE__*/_jsx(Pill, _objectSpread({
      onDelete: removeItem,
      deleteLabel: i18n.t('actions_delete')
    }, commonPillProps), item.id);
  }
  return /*#__PURE__*/_jsx(Pill, _objectSpread({}, commonPillProps), item.id);
}
function getStatusMessage() {
  var emptyMenuMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : i18n.t('no_search_suggestions_found');
  return function (_ref2) {
    var resultCount = _ref2.resultCount,
      inputValue = _ref2.inputValue;
    if (!inputValue) {
      return '';
    }
    if (!resultCount) {
      return emptyMenuMessage;
    }
    if (resultCount > 0) {
      return i18n.t('search_navigation_available_suggestions', {
        count: resultCount
      });
    }
    return '';
  };
}
var MultiSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var selectedItems = props.selectedItems,
    options = props.options,
    optionsLabel = props.optionsLabel,
    inputValue = props.inputValue,
    _props$getMenuItemLab = props.getMenuItemLabel,
    getMenuItemLabel = _props$getMenuItemLab === void 0 ? getDefaultMenuItemLabel : _props$getMenuItemLab,
    emptyMenuMessage = props.emptyMenuMessage,
    onSelectItem = props.onSelectItem,
    onRemoveItem = props.onRemoveItem,
    onInputValueChange = props.onInputValueChange,
    placeholder = props.placeholder,
    stealthy = props.stealthy,
    onFocus = props.onFocus,
    _props$itemRenderer = props.itemRenderer,
    itemRenderer = _props$itemRenderer === void 0 ? defaultItemRenderer : _props$itemRenderer,
    idProp = props.id,
    ariaDescribedBy = props['aria-describedby'],
    isDisabled = props.isDisabled;
  var _useFormFieldContext = useFormFieldContext({
      id: idProp,
      descriptionIds: ariaDescribedBy
    }),
    id = _useFormFieldContext.id,
    descriptionIds = _useFormFieldContext.descriptionIds;
  var inputRef = useRef(null);
  var mergedRefs = useMergedRefs([inputRef, ref]);
  function handleInputChange(event) {
    onInputValueChange(event.target.value);
  }
  function addItem(item) {
    var _inputRef$current;
    if (item.disabled) {
      return;
    }
    var selectedOption = options.find(function (option) {
      if (isDivider(option) || isGroupLabel(option)) {
        return false;
      }
      return option.value === item.value;
    });
    onSelectItem(selectedOption);
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
  }
  function removeItem(item) {
    var _inputRef$current2;
    onRemoveItem(item);
    (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.focus();
  }
  function removeLastItem() {
    if (selectedItems.length > 0) {
      removeItem(selectedItems[selectedItems.length - 1]);
    }
  }
  function handleBackspace(event) {
    var _event$currentTarget = event.currentTarget,
      selectionStart = _event$currentTarget.selectionStart,
      selectionEnd = _event$currentTarget.selectionEnd;
    var isCursorAtStart = selectionStart === 0 && selectionEnd === 0;
    if (event.key === KEY.BACKSPACE && isCursorAtStart) {
      removeLastItem();
    }
  }
  function select(selectedItem) {
    var isNotADuplicate = !selectedItems.find(function (item) {
      return item.value === selectedItem.value;
    });
    if (isNotADuplicate) {
      addItem(selectedItem);
    }
    onInputValueChange('');
  }
  return /*#__PURE__*/_jsxs(Combobox, {
    id: id,
    inputValue: inputValue,
    resultCount: options.length,
    getStatusMessage: getStatusMessage(emptyMenuMessage),
    shouldShowStatusMessage: inputValue.length > 1 && !options.length,
    onInputChange: handleInputChange,
    onSelect: select,
    children: [/*#__PURE__*/_jsx(ComboboxInput, {
      as: TagInput,
      stealthy: stealthy,
      "aria-describedby": descriptionIds,
      refKey: "wrapperRef",
      ref: mergedRefs,
      onFocus: onFocus,
      onKeyDown: handleBackspace,
      placeholder: selectedItems.length ? '' : placeholder,
      disabled: isDisabled,
      children: selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map(function (item) {
        return itemRenderer({
          item: item,
          removeItem: isDisabled ? undefined : function () {
            return removeItem(item);
          }
        });
      })
    }), /*#__PURE__*/_jsx(ComboboxMenu, {
      "aria-label": optionsLabel,
      children: options.map(function (item, index) {
        if (isDivider(item)) {
          return /*#__PURE__*/_jsx(ComboBoxMenuItemDivider, {}, index);
        } else if (isGroupLabel(item)) {
          return /*#__PURE__*/_jsx(ComboBoxMenuGroupLabel, {
            children: item.label
          }, item.label);
        } else return /*#__PURE__*/_jsx(ComboboxMenuItem, {
          value: item.value,
          icon: item.icon,
          isDisabled: item.isDisabled,
          children: getMenuItemLabel(item)
        }, item.id || item.value);
      })
    })]
  });
});
MultiSelect.displayName = 'MultiSelect';
export default MultiSelect;